export const compactView = "@media not screen, screen and (max-width: 1009px)";
export const regularView = "@media screen and (min-width: 1010px)";
export const badgeTop = 11;
export const cardOverlay = 4;
export const compactMargin = 20;
